<template>
	<div>
		<WmsTable
			rowKey="inboundCode"
			v-bind="$attrs"
			:isPagination="query"
			:columns="newColumns"
			isExpanded_hidden
			@selectChange="selectChangeCall"
			@pageChange="pageChangeCall"
			@expendOpen="expendOpen"
			:dataSource="tableData"
			listener
			ref="wmsTable_inbound"
			:keepExpended="true"
			:hasHeader="false"
		>
			<div slot="inboundCode" slot-scope="{ text, record, index }">
				{{ text }}
				<div class="customerTag" v-if="record.hasKeyCustomer">
					<div>重</div>
				</div>
			</div>
			<div
				slot="action"
				style="display: flex; flex-wrap: wrap"
				slot-scope="{ text, record, index }"
			>
				<el-button type="text" @click="toDetail(record)">详情</el-button>
				<template v-if="inboundType == 1 && tableType == 3">
					<!-- <span class="span__btn" @click="toDetail(record)">| 获取最新库存</span> -->
					<el-button
						:disabled="!record.enableInbound"
						type="text"
						class="span__btn"
						@click="openConfirm(record)"
						>| 一键入库 |
					</el-button>
					<el-button type="text" @click="close(record)" style="color: #f73131"
						>关闭</el-button
					>
				</template>
			</div>
			<div slot="expressNoList" slot-scope="{ text, record, index }">
				<ellipsisDiv :text="text.join(',')"></ellipsisDiv>
			</div>
			<div slot="closeReason" slot-scope="{ text, record, index }">
				<ellipsisDiv :text="text"></ellipsisDiv>
			</div>
			<template slot="expandedRender" slot-scope="{ record }">
				<WmsTable
					:columns="realColumsSon"
					:isPagination="false"
					:hasHeader="false"
					:dataSource="record.sonArray"
					:ref="`table_expended_${record.inboundCode}`"
				>
					<ImgView
						slot="productImgAction"
						slot-scope="{ text, record, index }"
						:src="text"
						:width="40"
						:height="40"
					/>
					<div slot="productSku_purchase" slot-scope="{ text, record, index }">
						<a
							v-if="record.productLink"
							:href="record.productLink"
							target="_blank"
						>
							{{ record.productSku }}</a
						>
						<div v-else>{{ record.productSku }}</div>

						<template
							v-if="record.customerTagList && record.customerTagList.length"
						>
							<div
								class="customerTag"
								v-for="(i, index) in record.customerTagList"
								:key="index"
								v-if="i.customerTagName"
							>
								{{ i.customerTagName }}
							</div>
						</template>
						<div
							v-if="record.ingredientType"
							:class="`ingredientTag ${
								record.ingredientType == 1 ? 'ingredientTagYellow' : ''
							}`"
						>
							{{ ingredientTypeList[record.ingredientType] }}
						</div>
						<el-tag
							type="warning"
							effect="dark"
							v-if="record.allIncludeFlag === 1"
							>一价全包</el-tag
						>

						<a
							v-if="record.productCode"
							target="_blank"
							:href="`https://s.theckb.com/ja/goods/${record.productCode}`"
						>
							CKB链接
						</a>
					</div>
					<div slot="productSku" slot-scope="{ text, record, index }">
						<div v-if="bindStatus(record) == 'select'">
							选择规格后显示平台SKU
						</div>
						<template v-else>
							<a
								v-if="record.productLink"
								:href="record.productLink"
								target="_blank"
							>
								{{ record.productSku }}</a
							>
							<div v-else>{{ record.productSku }}</div>
							<template
								v-if="record.customerTagList && record.customerTagList.length"
							>
								<div
									class="customerTag"
									v-for="(i, index) in record.customerTagList"
									:key="index"
									v-if="i.customerTagName"
								>
									{{ i.customerTagName }}
								</div>
							</template>
							<div
								v-if="record.ingredientType"
								:class="`ingredientTag ${
									record.ingredientType == 1 ? 'ingredientTagYellow' : ''
								}`"
							>
								{{ ingredientTypeList[record.ingredientType] }}
							</div>
						</template>
					</div>
					<div slot="productProp" slot-scope="{ text, record, index }">
						<!-- <el-select :disabled="!record.enableEditProp || record.inboundStatus != 0" v-model="record.productProp" -->
						<el-select
							:disabled="true"
							v-model="record.productProp"
							style="width: 250px"
							filterable
							@change="propChange($event, record)"
						>
							<el-option
								:label="item.productPropertiesName"
								:value="item.productPropertiesName"
								v-for="item in record.productPropList"
								:key="item.productSku"
							></el-option>
						</el-select>
					</div>

					<div slot="purchaseNum" slot-scope="{ text, record, index }">
						<span class="span__btn" @click="getPurchaseNum(record)">{{
							text
						}}</span>
					</div>
					<div slot="realImportNum" slot-scope="{ text, record, index }">
						<span class="span__btn" @click="getInstockNum(record, 1)">{{
							text
						}}</span>
					</div>
					<div slot="exceptionCustomerNum" slot-scope="{ text, record, index }">
						<span class="span__btn" @click="getInstockNum(record, 3)">{{
							text
						}}</span>
					</div>
					<div slot="exceptionPurchaseNum" slot-scope="{ text, record, index }">
						<span class="span__btn" @click="getInstockNum(record, 4)">{{
							text
						}}</span>
					</div>
					<div slot="badNum" slot-scope="{ text, record, index }">
						<span class="span__btn" @click="getInstockNum(record, 2)">{{
							text
						}}</span>
					</div>
					<div slot="action_son" slot-scope="{ text, record, index }">
						<el-button type="text" @click="getGoodsInfo(record)"
							>商品信息</el-button
						>
						<el-button
							:disabled="!!record.inboundStatus"
							type="text"
							@click="handleCancelSku(record)"
							v-if="tableType == 3"
							>取消入库</el-button
						>
					</div>
				</WmsTable>
			</template>
		</WmsTable>

		<purchaseNum
			:visible="getPurchaseNumVisible"
			:data="getPurchaseNumData"
			@close="getPurchaseNumVisible = false"
		>
		</purchaseNum>
		<instockNum
			:visible="instockVisble"
			:data="instockList"
			@close="instockVisble = false"
		></instockNum>
		<detailSpider
			@refresh="$emit('overEmit')"
			ref="detailSpider"
		></detailSpider>
		<InstockConfirm ref="instockConfirm" @refresh="$emit('overEmit')" />
	</div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ellipsisDiv from "@/components/WmsTable/ellipsisDiv";
import ImgView from "@/components/ImgView";
import purchaseNum from "./purchaseNum.vue";
import instockNum from "./instockNum.vue";
import detailSpider from "./detailSpider.vue";
import InstockConfirm from "./InstockConfirm.vue";
import { Table } from "ant-design-vue";
import {
	inboundSkuInfo,
	closeInboundOrder,
	purchaseNumInfo,
	inboundNumInfo,
	detailSpiderByUrl,
	updateProp,
	updateByUrl,
	getOneKeyInfoListApi,
	updatePropApi,
	cancelSku,
} from "@/apis/inHouse";
import {
	columns,
	columns_son,
	columns_son_purchase,
	handleAction,
	closeColums,
	columns_purchase,
} from "./InterListData";
import { customerTagMap } from "@/types/customer";
import { ingredientTypeList } from "@/types/index";

export default {
	name: "InterList",
	components: {
		[Table.name]: Table,
		WmsTable,
		ImgView,
		purchaseNum,
		instockNum,
		detailSpider,
		InstockConfirm,
		ellipsisDiv,
	},
	props: {
		layout: {
			type: String,
			default: () => {
				return "";
			},
		},
		total: {
			type: String | Number,
		},
		dataSource: {
			type: Array,
			default: (_) => {
				return [];
			},
		},
		forwarder: {
			type: Array,
			default: () => [],
		},
		tableType: {
			type: String,
		},
		inboundType: {
			type: Number,
		},
	},
	data() {
		return {
			columns,
			columns_purchase,
			columns_son,
			columns_son_purchase,
			handleAction,
			closeColums,
			selRow: [],
			tableData: [],
			targetLeft: 0,
			query: {
				current: 1,
				pageSize: 20,
				total: 0,
			},
			createVisible: false,

			getPurchaseNumData: [],
			getPurchaseNumVisible: false,
			instockVisble: false,
			instockList: [],
			detailSpiderVisible: false,
			detailSpiderData: {},
			customerTagMap,
			ingredientTypeList,
		};
	},
	watch: {
		total: {
			immediate: true,
			handler: function (newVal, oldVal) {
				this.query.total = newVal;
			},
			immediate: true,
			keep: true,
		},
		dataSource: {
			immediate: true,
			handler: function (newVal, oldVal) {
				if (newVal) {
					this.tableData = [...newVal];
				}
			},
			immediate: true,
			keep: true,
		},
	},
	computed: {
		newColumns: function () {
			let _columns = [...(this.inboundType == 1 ? columns : columns_purchase)];
			if (this.inboundType == 0) {
				_columns.push({
					title: "签收时间",
					key: "signTime",
					dataIndex: "signTime",
					rowKey: "key",
				});
			}
			if (this.inboundType == 1 && this.tableType == 5) {
				_columns = _columns.concat(closeColums);
			} else {
				_columns.push(handleAction);
			}
			return _columns;
		},
		realColumsSon: function () {
			return this.inboundType === 0
				? columns_son_purchase
				: this.inboundType === 1
				? columns_son
				: [];
		},
	},
	methods: {
		setUseable(Str) {
			return !this.layout.includes(Str);
		},
		matchForwarder(data) {
			let has = this.forwarder.some((item) => {
				if (item.intForwarderConfigId == data.wmsIntForwarderConfigId) {
					return true;
				}
			});
			has = has
				? data.wmsIntForwarderConfigId
				: data.wmsForwarder + "-" + data.wmsShippingType;
			return has;
		},
		pageChangeCall: function (payload) {
			this.query.current = payload.current;
			this.query.pageSize = payload.pageSize;
			this.$emit("pageChange", payload);
		},
		selectChangeCall: function (rows) {
			this.selRow = rows;
			this.$emit("selectChange", rows);
		},
		resetPage() {
			this.query.current = 1;
			this.$refs.wmsTable_inbound.resetExpended();
			this.$refs.wmsTable_inbound.resetSel();
		},
		toDetail(record) {
			this.$router.push({
				path: "/inHouse_inboundDetail",
				query: {
					inboundCode: record.inboundCode,
					purchaseUserName: record.purchaseUserName,
					purchaseNoList: record.purchaseNoList.join(","),
					expressNoList: record.expressNoList.join(","),
					creatorName: record.creatorName,
					inboundType: this.inboundType,
				},
			});
		},
		expendOpen(record) {
			if (record.inboundCode) {
				inboundSkuInfo({ inboundCode: record.inboundCode }).then((res) => {
					if (res.success) {
						let index = this.tableData.findIndex(
							(item) => item.inboundCode == record.inboundCode
						);
						this.$refs.wmsTable_inbound.changeDataSourceData(
							index,
							"sonArray",
							res.data
						);
					}
				});
			}
		},
		bindStatus(record) {
			let { productCode, productSku } = record;
			if (!productCode) {
				return "btn";
			} else if (productCode && !productSku) {
				return "select";
			}
			return "text";
		},
		close(record) {
			this.$prompt("关闭原因：", "请确定是否要关闭入库单", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(({ value }) => {
					let params = {
						closeReason: value,
						inboundCode: record.inboundCode,
					};
					closeInboundOrder(params).then((res) => {
						if (res.code == 0) {
							this.$message.success("成功");
							this.$emit("overEmit");
						}
					});
				})
				.catch(({ value }) => {});
		},
		getPurchaseNum(record) {
			console.log(record);
			purchaseNumInfo({
				inboundItemId: record.id,
			}).then((res) => {
				if (res.code == 0) {
					this.getPurchaseNumData = res.data;
					this.getPurchaseNumVisible = true;
				}
			});
		},
		getInstockNum(record, type) {
			inboundNumInfo({
				inboundItemId: record.id,
				pkgType: type,
			}).then((res) => {
				if (res.code == 0) {
					this.instockList = res.data;
					this.instockVisble = true;
				}
			});
		},
		getGoodsInfo(record) {
			this.detailSpiderVisible = true;
			this.detailSpiderData = record;
		},
		propChange($event, record) {
			let item = record.productPropList.filter(
				(item) => item.productPropertiesName == $event
			)[0];
			let params = {
				inboundItemId: record.id,
				productCode: record.productCode,
				productProp: $event,
				productSku: item.productSku,
				productName: record.productName,
				productImg: item.productSkuImg,
				productLink: record.productLink,
			};
			updateProp(params).then((res) => {
				if (res.code == 0) {
					this.$message.success("成功");
					this.$emit("overEmit");
				}
			});
		},
		handleUpdateByUrl(record) {
			let params = {
				inboundItemId: record.id,
				productLink: record.productLink,
			};
			updateByUrl(params).then((res) => {
				if (res.code == 0) {
					this.$message.success("成功");
					this.$emit("overEmit");
				}
			});
		},
		getGoodsInfo(record) {
			this.$refs.detailSpider.open(record);
		},
		changeProp(e, record) {
			let productProp = "";
			record.productPropList.forEach((item) => {
				if (item.productSku === e) {
					productProp = item.productPropertiesName;
				}
			});
			updatePropApi({
				inboundItemId: record.id,
				productCode: record.productCode,
				productImg: record.productImg,
				productLink: record.productLink,
				productName: record.productName,
				productProp: productProp,
				productPropList: record.productPropList,
				productSku: e,
			}).then(() => {
				this.$message.success("修改成功！");
			});
		},
		openConfirm(record) {
			getOneKeyInfoListApi({
				inboundCode: record.inboundCode,
			}).then((res) => {
				if (res.code == 0) {
					this.$refs.instockConfirm.open(record, res.data);
				}
			});
		},
		handleCancelSku(record) {
			this.$confirm(`请确定是否要取消该商品入库`, "", {
				confirmButtonText: "确认",
				type: "error",
				cancelButtonText: "取消",
			}).then(() => {
				cancelSku({ inboundItemId: record.id }).then((res) => {
					if (res.code == 0) {
						this.$message.success("成功");
						this.$emit("overEmit");
					}
				});
			});
		},
		checkOneTapStatus(record) {
			return false;
		},
	},
};
</script>

<style scoped>
.ant-table-expanded-row .son__table--customize >>> td,
.son__table--customize >>> th {
	border-right: 0px solid #e8e8e8 !important;
}

.shipmentCode__span {
	position: relative;
	top: 0;
	left: 0;
	display: block;
	line-height: 24px;
}

.shipment__error::before {
	position: absolute;
	bottom: 0;
	left: 0;
	content: "运单号获取异常";
	display: block;
	height: 24px;
	line-height: 24px;
	font-size: 12px;
	color: red;
}

.span__btn {
	cursor: pointer;
	padding: 1px 0;
	margin: 2px;
	color: #40a9ff;
}

::v-deep .headerClass {
	background-color: #ddeefe !important;
}

::v-deep .ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
	width: 50px !important;
}

::v-deep .el-dialog__body {
	padding: 5px 20px;
}

::v-deep .el-collapse-item__content {
	padding-bottom: 0px;
}

::v-deep .el-descriptions__header {
	margin-bottom: 5px;
}

::v-deep .el-dialog {
	margin: 0 auto;
}

.dialogTitle {
	height: 60px;
	width: 100%;
	font-size: 20px;
	text-align: center;
	line-height: 60px;
	background-color: #00284d;
	color: #e8e8e8;
}

.customerTag {
	min-height: 24px;
	min-width: 24px;
	padding: 0 2px;
	border-radius: 4px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: white;
	background-color: red;
	line-height: 24px;
	font-size: 12px;
	margin-right: 4px;
}

.ingredientTag {
	min-height: 20px;
	min-width: 20px;
	padding: 0 2px;
	border-radius: 4px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: white;
	background-color: #409eff;
	line-height: 20px;
	font-weight: 900;
	margin-right: 4px;
}

.ingredientTagYellow {
	background-color: #e6a23c;
}
</style>
